import { render, staticRenderFns } from "./shopGroupForm.vue?vue&type=template&id=6a06b7d4&scoped=true"
import script from "./shopGroupForm.vue?vue&type=script&lang=js"
export * from "./shopGroupForm.vue?vue&type=script&lang=js"
import style0 from "./shopGroupForm.vue?vue&type=style&index=0&id=6a06b7d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a06b7d4",
  null
  
)

export default component.exports